import { AsyncPipe, DatePipe, NgOptimizedImage } from '@angular/common';
import { Component, inject, Input } from '@angular/core';
import dayjs from 'dayjs/esm';
import { LIB_CONFIG } from '../../../lib.config';
import { BildungsangebotTerminDetail } from '../../../model';
import { ScreenSizeService, ViewMode } from '../../../services/screen-size';
import { NoReferrerDirective } from '../../../shared/directives';
import { ANBIETER_LOGO_FALLBACK } from '../../../shared/utils/anbieter-logo-fallback';
import { DauerAnzeigeComponent } from '../../dauer-anzeige/dauer-anzeige.component';
import {
  FavoriteToggleComponent,
  Weiterbildung
} from '../favorite-toggle/favorite-toggle.component';
import { getLabelFromWeiterbildungsart } from '../../../model/weiterbildungsarten';
import { breakTitle } from '../../../shared/utils/break-title';

@Component({
  selector: 'now-wbsuche-lib-detail-header',
  templateUrl: './detail-header.component.html',
  styleUrls: ['./detail-header.component.scss'],
  imports: [
    NgOptimizedImage,
    DauerAnzeigeComponent,
    NoReferrerDirective,
    FavoriteToggleComponent,
    AsyncPipe,
    DatePipe
  ]
})
export class DetailHeaderComponent {
  private readonly screenSizeService = inject(ScreenSizeService);

  @Input() termin!: BildungsangebotTerminDetail;

  public isNowWbSuche = inject(LIB_CONFIG).isNowWbSuche;

  public readonly KEINE_ANGABE = 'Keine Angabe';

  public isTablet$ = this.screenSizeService.rangeTo$(ViewMode.TABLET);

  public hasImgError = false;

  get breakTitle(): string {
    return breakTitle(this.termin?.angebot.titel);
  }

  get anbieterLogo(): string {
    return this.hasImgError
      ? ANBIETER_LOGO_FALLBACK
      : this.termin.angebot.bildungsanbieter?.logo || ANBIETER_LOGO_FALLBACK;
  }

  get favoriteEntity(): Weiterbildung {
    return {
      basisdienst: 'WEITERBILDUNG',
      favoritTitle: this.termin.angebot.titel,
      targetId: this.termin.id,
      detailsBegin: this.msToYYYYMMDD(this.termin.beginn),
      detailsEnd: this.msToYYYYMMDD(this.termin.ende),
      detailsLocation: this.termin.adresse?.ort
    };
  }

  get weiterbildungsart(): string {
    return getLabelFromWeiterbildungsart(this.termin.angebot.weiterbildungsart);
  }

  private msToYYYYMMDD(timestampInMilliseconds: number | null): string | undefined {
    return timestampInMilliseconds
      ? dayjs(timestampInMilliseconds).format('YYYY-MM-DD')
      : undefined;
  }
}
